
import { GlobalState } from '@/shared/models/GlobalState';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import EstateAgentProfile from '@/estate-agent/EstateAgentProfile.vue';
import UserBasicProfile from '@/account/UserBasicProfile.vue';

export default defineComponent({
  name: 'UserProfile',
  components: {
    EstateAgentProfile,
    UserBasicProfile,
  },
  computed: {
    ...mapState({
      user: state => (state as GlobalState).user,
    }),
  },
});
